export default __webpack_public_path__ + "static/media/r1.483de44e.jpeg";